import styled from "styled-components";

export const Container = styled.div`
  max-width: 100%;
  background: #ffffff;
  padding-left: 250px;
`;

export const Title = styled.h1`
  width: 100%;
  /* max-width: 1100px; */

  /* margin:0px auto 15px auto; */
  padding: 1rem;

  color: #000000;

  border-bottom: 1px solid rgba(0, 0, 0, 0.15);

  font-size: 28px;
  font-family: sans-serif;
  font-weight: 600;
`;

export const ContentSquad = styled.div`
  padding: 1rem;
`;
export const RankingFrame = styled.div`
  background: #f7f8fa;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  padding: 2rem;
  max-width: 900px;
  margin: 2rem auto;
`;

export const Top2Container = styled.div`
  display: flex;
  gap: 2rem;
  justify-content: center;
  margin-bottom: 2rem;
`;

export const TopCard = styled.div`
  background: ${({ highlight }) => (highlight ? "#ffe082" : "#fff")};
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 2rem 2.5rem;
  min-width: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: ${({ highlight }) =>
    highlight ? "2px solid #ffd600" : "1px solid #e0e0e0"};
`;

export const Position = styled.div`
  font-size: 2.5rem;
  font-weight: bold;
  color: var(--color-primary);
  margin-bottom: 0.5rem;
`;

export const Name = styled.div`
  font-size: 1.3rem;
  font-weight: 600;
  color: #222;
`;

export const Email = styled.div`
  font-size: 0.95rem;
  color: #888;
  margin-bottom: 0.5rem;
`;

export const IndicationsComponent = styled.div`
  font-size: 1.1rem;
  color: #1976d2;
  font-weight: 500;
`;

export const RestList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 520px;
  overflow-y: auto;
  border-top: 1px solid #ececec;
`;

export const RestItem = styled.li`
  display: flex;
  align-items: center;
  padding: 0.7rem 0.5rem;
  border-bottom: 1px solid #f0f0f0;
  font-size: 1rem;
  background: #fff;
  transition: background 0.2s;
  &:hover {
    background: #f5f5f5;
  }
`;

export const RestPosition = styled.div`
  width: 2.5rem;
  font-weight: 600;
  color: #888;
`;

export const RestName = styled.div`
  flex: 1;
  color: #222;
`;

export const RestIndications = styled.div`
  color: #1976d2;
  font-weight: 500;
`;

export const ContainerTotal = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem 1.5rem 1rem;
  background: #f0f4ff;
  border-radius: 12px;
  margin: 0 auto 2rem auto;
  box-shadow: 0 1px 6px rgba(25, 118, 210, 0.07);
  max-width: 400px;
`;

export const TotalLabel = styled.p`
  font-size: 1.1rem;
  color: #1976d2;
  margin: 0 0 0.5rem 0;
  font-weight: 500;
`;

export const TotalNumber = styled.strong`
  font-size: 2.5rem;
  color: #0d47a1;
  font-weight: 700;
  background: #e3f2fd;
  padding: 0.3em 1em;
  border-radius: 2em;
  letter-spacing: 1px;
`;
